import React from "react";
import { Result } from "antd";

import { i18, trb } from "@utilities";

export const SuccessApproveContainer = () => {
  return (
    <div className="text-center" style={{ marginLeft: "auto", marginRight: "auto" }}>
      <Result
        status="success"
        className="mb-3"
        title={trb(i18.NotificationTitles.KycSuccessApprove)}
      />
    </div>
  );
};
